import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tabs, Spin } from "antd";
import { getStyleProperties } from "../../utils/CustomFunc";
import { LoadingOutlined } from "@ant-design/icons";
import { deepEqual } from "../../utils/CustomFunc";
import liracrypt from "../../components/Liracrypt/liracrypt";
import SessionError from "../../components/ApiErrorComp/SessionError";

const { TabPane } = Tabs;

const RightContainer = (props) => {
  const [loginError, setLoginError] = useState(false);

  const [rightContainer, setRightContainer] = useState(null);
  const [selectedTab, setSelectedTab] = useState("PerformanceTrend");
  const [addonLoaded, setAddonLoaded] = useState(false);
  const [andonstatus, setAndonstatus] = useState(null);

  const [andonBlock, setAndonBlock] = useState(null);
  const [isFlipped, setIsFlipped] = useState(false);

  // const [andonstatusLoaded, setAndonstatusLoaded] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  const fetchAndonDetail = () => {
    liracrypt
      .get("/linedashboard/andonstatus", { lid: props.selectedLid })
      .then(({ data }) => {
        // console.log(data);
        
        if (!andonstatus) {
          setAndonstatus(data.data);
          setAndonBlock(data.data.escDetails);
        } else {
          if (!deepEqual(andonstatus, data)) {
            setAndonstatus(data.data);
          }
        }
        setAddonLoaded(true);
      })
      .catch(function (error) {
        console.log("Error****:", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    // fetchAndonDetail();

    // setInterval(() => {
    if (rightContainer === null) {
      let dataBlock = [];

      Object.keys(props.settings).forEach((key, index) => {
        // console.log(key);
        if (key.includes("ld_DataBlock_")) {
          dataBlock.push({
            text: props.settings[key].text,
            text_style: getStyleProperties(props.settings[key].legend),
            value: props.settingValues[key],
            value_style: getStyleProperties(props.settings[key].data),
            numbeOfBlock: props.settings.ld_main.dataBlocks,
            backgroundColor: props.settings[key]["background-color"],
            width: 80 / props.settings.ld_main.dataBlocks + "%",
          });
        }
      });

      // console.log(dataBlock);

      setRightContainer({
        dataBlock: dataBlock,
        andon: props.settings.ld_Andon,
        tabs: props.settings.ld_Tab_Main,
      });
    }
    // }, 10000);
  }, [props]);

  const DBlocks = () => {
    return (
      <Row align="middle" style={{ marginLeft: 0, marginRight: 0 }}>
        {rightContainer.dataBlock &&
          rightContainer.dataBlock.map((data, index) => {
            // console.log(data, index);
            return (
              <Col span={9}>
                <div
                  style={{
                    textAlign: "center",
                    padding: "5px 20px",
                    margin: "10px",
                    // borderTop: "1px solid #585757c7",
                    // borderLeft: "1px solid #585757c7",
                    border: 0,
                    backgroundColor: data["background-color"]
                      ? data["background-color"]
                      : "#262626",
                    // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                  className="borderBox"
                >
                  <p
                    style={{
                      ...data["dataStyle"],
                      margin: "2px 0",
                      fontSize: "40px",
                      color: "rgb(255, 230, 0)",
                    }}
                  >
                    {/* {localStorage.getItem(`DataBlock${index + 1}`)} */}
                    {props.dBlock["lD_DataBlock_0" + (index + 1)]}
                  </p>
                  <p
                    style={{
                      ...data["labelStyle"],
                      margin: "2px 0",
                      fontSize: "18px",
                    }}
                  >
                    {data["text"] ? data["text"] : "DataBlock"}
                  </p>
                </div>
              </Col>
            );
          })}
      </Row>
    );
  };

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {rightContainer !== null ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <DBlocks />
              {/* {rightContainer.dataBlock.map((block, index) => {

                let loc = index + 1;
                let locNext = loc + 4;

                return (
                  <>
                    {rightContainer.dataBlock[loc - 1] &&
                    rightContainer.dataBlock[locNext - 1] ? (
                      <>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "center",
                              padding: "5px 20px",
                              border: 0,
                              backgroundColor: block.backgroundColor,
                              boxShadow:
                                "5px 5px 9px #171717,-5px -5px 9px #232323",
                              borderRadius: "10px",
                              fontWeight: "600",
                            }}
                            className="borderBox"
                          >
                            <p
                              style={{
                                ...block.value_style,
                                margin: "2px 0",
                              }}
                            >
                              {props.dBlock["lD_DataBlock_0" + loc]}
                            </p>
                            <p
                              style={{
                                ...block.text_style,
                                margin: "2px 0",
                                fontSize: "14px",
                              }}
                            >
                              {block.text}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "center",
                              padding: "5px 20px",
                              border: 0,
                              backgroundColor:
                                rightContainer.dataBlock[locNext - 1]
                                  .backgroundColor,
                              boxShadow:
                                "5px 5px 9px #171717,-5px -5px 9px #232323",
                              borderRadius: "10px",
                              fontWeight: "600",
                            }}
                            className="borderBox"
                          >
                            <p
                              style={{
                                ...rightContainer.dataBlock[locNext - 1]
                                  .value_style,
                                margin: "2px 0",
                              }}
                            >
                     
                              {props.dBlock["lD_DataBlock_0" + (locNext - 1)]}
                            </p>
                            <p
                              style={{
                                ...rightContainer.dataBlock[locNext - 1]
                                  .text_style,
                                margin: "2px 0",
                                fontSize: "14px",
                              }}
                            >
                              {rightContainer.dataBlock[locNext - 1].text}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                );
              })} */}
            </div>
          </>
        ) : null}
      </React.Fragment>
    </>
  );
};
export default RightContainer;
